export default "__VITE_ASSET__DweMGjMk__"